import './component.scss'
import $ from 'jquery'
import 'slick-carousel'
import 'Components/refosumu/basics/breadcrumb/component'
import 'Components/refosumu/example_info/component'
import 'Components/refosumu/character_voice/component'
import 'Components/refosumu/example_before_after_images/component'
import 'Components/refosumu/carousel_light/component'
import 'Components/refosumu/example_card/component'
import 'Components/refosumu/review_card/component'
import 'Components/refosumu/company_card/component'
import 'Components/basics/truncate_text/component'
import './images/refolow.webp'
import './images/customer_request.webp'
import './images/company_request.webp'
import './images/icon.svg'
import './images/yellow-arrow.svg'
import './images/in_preparation.webp'
import './images/yen_mark_blue.svg'

const SLICK_TARGET_SELECTOR = '.js-slick-example-show-target'
const TABLET_WIDTH = 1000
const slickExampleOptions = {
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  centerMode: false
}

// スライダー初期化関数
function initializeSliders () {
  if (window.innerWidth <= TABLET_WIDTH) {
    // 表示されているタブ内のスライダーのみ初期化
    const visibleContainers = $('.renovation-example__tab-inner-container--visible')
    visibleContainers.find(SLICK_TARGET_SELECTOR).each(function() {
      if (!$(this).hasClass('slick-initialized')) {
        $(this).slick(slickExampleOptions)
      }
    })
  }
}

// リサイズ時の処理
$(window).on('resize', function () {
  if (window.innerWidth <= TABLET_WIDTH) {
    // 表示されているタブ内のスライダーのみ初期化
    const visibleContainers = $('.renovation-example__tab-inner-container--visible')
    visibleContainers.find(SLICK_TARGET_SELECTOR).each(function() {
      if (!$(this).hasClass('slick-initialized')) {
        $(this).slick(slickExampleOptions)
      }
    })
  } else {
    // 全てのスライダーを破棄
    $(SLICK_TARGET_SELECTOR).each(function() {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick')
      }
    })
  }
})

function initializeImageSwitcher() {
  const mainImage = document.querySelector('.renovation-example__photo')
  const subImages = document.querySelectorAll('.renovation-example__area-img')

  subImages.forEach(subImage => {
    subImage.addEventListener('click', (e) => {
      if (e.target.classList.contains('renovation-example__area-img--active')) return

      // サブ画像の選択状態切り替え
      subImages.forEach(img => {
        img.classList.remove('renovation-example__area-img--active')
      })
      e.target.classList.add('renovation-example__area-img--active')

      // 旧メイン画像をフェードアウト
      mainImage.classList.add('renovation-example__photo--fade-out')

      setTimeout(() => {
        mainImage.src = e.target.src

        // 新メイン画像をフェードイン
        mainImage.onload = () => {
          mainImage.classList.remove('renovation-example__photo--fade-out')
        }
      }, 300) // CSS transitionの時間と合わせる
    })
  })
}

// タブ機能の実装
document.addEventListener('DOMContentLoaded', function () {
  // タブアイテムとコンテナを取得
  const tabItems = document.querySelectorAll('.renovation-example__tab-item')
  const tabContainers = document.querySelectorAll('.renovation-example__tab-inner-container')

  // 初期表示の設定
  function initializeTabs () {
    // 全てのコンテナを非表示に
    tabContainers.forEach(container => {
      container.classList.remove('renovation-example__tab-inner-container--visible')
    })

    // アクティブなタブに対応するコンテナを表示
    const activeTab = document.querySelector('.renovation-example__tab-item--active')
    if (activeTab) {
      const tabKey = activeTab.getAttribute('data-tab-key')
      const targetContainer = document.querySelector(`[data-tab-key="${tabKey}"].renovation-example__tab-inner-container`)
      if (targetContainer) {
        targetContainer.classList.add('renovation-example__tab-inner-container--visible')
      }
    }
  }

  // タブクリック時の処理
  function handleTabClick (clickedTab) {
    const tabKey = clickedTab.getAttribute('data-tab-key')

    // 全タブのアクティブ状態をリセット
    tabItems.forEach(tab => {
      tab.classList.remove('renovation-example__tab-item--active')
    })

    // クリックされたタブをアクティブに
    clickedTab.classList.add('renovation-example__tab-item--active')

    // 全コンテナを非表示に
    tabContainers.forEach(container => {
      container.classList.remove('renovation-example__tab-inner-container--visible')
    })

    // 対応するコンテナを表示
    const targetContainer = document.querySelector(`[data-tab-key="${tabKey}"].renovation-example__tab-inner-container`)
    if (targetContainer) {
      targetContainer.classList.add('renovation-example__tab-inner-container--visible')

      // 新しく表示されたタブ内のスライダーを初期化（少し遅延させて確実に表示後に実行）
      setTimeout(() => {
        initializeSliders()
      }, 50)
    }
  }

  // イベントリスナーを設定
  tabItems.forEach(tab => {
    tab.addEventListener('click', function () {
      handleTabClick(this)
    })
  })

  // FV画像切り替え機能を初期化
  initializeImageSwitcher()

  // 初期化実行
  initializeTabs()

  // タブ初期化後にスライダーを初期化
  setTimeout(() => {
    initializeSliders()
  }, 100)
})
